module.exports = __webpack_public_path__ + "static/media/icon_soccer.a256a2ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_soccer.png
// module id = 138
// module chunks = 0